<template>
  <v-layout column class="mx-4 my-2 bordered overflow-hidden">
    <v-layout
      align-center
      class="text-xs-left primary--text pa-2 light-background"
    >
      <i
        v-if="!questionAnswered(question)"
        class="primary--text material-icons-outlined mr-2"
        style="font-size: 20px"
        slot="activator"
      >
        help_outline
      </i>
      <v-icon v-else class="success--text mr-2" size="20" slot="activator">
        task_alt
      </v-icon>
      <sx-html :text="question.text" />{{
        question.optional ? ' (optional)' : ''
      }}
      <v-chip small class="my-0" v-if="question.answer_by && !question.answer"
        >Marked to be
        {{ question.question_type === 'upload' ? 'uploaded' : 'answered' }} by
        {{ moment(question.answer_by).format('ll') }}</v-chip
      >
      <v-spacer />
      <v-tooltip bottom class="mx-2">
        <div slot="activator">
          <i
            class="primary--text"
            :class="
              filteredComments(question).length > 0
                ? 'material-icons'
                : 'material-icons-outlined'
            "
            style="cursor: pointer;font-size: 18px"
            @click="$emit('open-comment-dialog', question)"
          >
            chat
          </i>
        </div>

        <span>View Notes ({{ filteredComments(question).length }})</span>
      </v-tooltip>
      <v-tooltip
        bottom
        class="mx-2"
        v-if="
          showQuestionActions && (isEmpty(question.answer) || isSorabanAdmin)
        "
      >
        <v-icon
          slot="activator"
          class="success--text"
          size="20"
          @click="$emit('toggle-completed', question)"
        >
          check
        </v-icon>
        <span>Mark Completed</span>
      </v-tooltip>
      <v-tooltip bottom class="mx-2" v-if="showQuestionActions">
        <v-icon
          slot="activator"
          class="error--text"
          size="20"
          @click="$emit('delete-question', question)"
        >
          delete_outline
        </v-icon>
        <span>Remove</span>
      </v-tooltip>
    </v-layout>
    <v-divider style="border-color: #e9efff" />
    <span
      class="ml-5 my-1 darkgrey--text"
      v-if="predefinedQuestionAnswers.includes(question.answer)"
    >
      {{ question.answer }}{{ uploadLaterDate(question) }}
      <v-icon
        slot="activator"
        v-if="showQuestionActions && question.answer === 'Marked Completed'"
        class="error--text"
        size="18"
        @click="$emit('toggle-completed', question)"
      >
        cancel
      </v-icon>
    </span>
    <v-layout
      column
      class="ml-5 my-1 grey--text text--darken-3"
      v-else-if="
        question.answer ||
          (question.question_type === 'upload' && allowFileSelection)
      "
    >
      <v-layout
        align-start
        column
        v-if="
          question.question_type === 'entries' &&
            !predefinedQuestionAnswers.includes(question.answer)
        "
        class="mt-2 mr-4"
      >
        <v-layout
          align-center
          wrap
          class="outlined py-2 mb-2"
          :key="entryNumber"
          v-for="(entryNumber, i) in getTriggers(question)"
        >
          <v-avatar class="my-1 ml-2 primary white--text" size="20">{{
            i + 1
          }}</v-avatar>
          <v-layout
            align-start
            :key="i"
            v-for="(followUpQuestion, i) in getFollowUpQuestionsWithTrigger(
              question,
              entryNumber,
            )"
          >
            <!-- <v-layout column align-start class="my-1" :key="i" v-for="(followUpQuestion, i) in getFollowUpQuestions(question)"> -->
            <v-layout align-center class="grey--text text--darken-2 px-3">
              <div class="mr-2"><span v-html="followUpQuestion.text" />:</div>
              <template v-if="followUpQuestion.answer">
                <template v-if="followUpQuestion.question_type === 'upload'">
                  <v-tooltip
                    bottom
                    :key="i"
                    v-for="(document, i) in listDocuments(
                      followUpQuestion.answer,
                    )"
                  >
                    <v-chip
                      slot="activator"
                      small
                      @click="
                        $emit(
                          'preview-document',
                          findExtractedDocument(document),
                        )
                      "
                    >
                      {{ getDocumentName(document) }}
                    </v-chip>
                    <span
                      v-if="
                        endsWithAny(supportedExtensionsForPreview, document)
                      "
                      >Click to preview</span
                    >
                    <span v-else>Click to download</span>
                  </v-tooltip>
                </template>
                <div v-else class="font-weight-bold">
                  {{ followUpQuestion.formatted_answer }}
                </div>
              </template>
              <div v-else class="grey--text">Blank</div>
            </v-layout>
          </v-layout>
        </v-layout>
        <v-flex
          class="mb-2 font-weight-bold"
          v-if="isEmpty(getTriggers(question))"
          >None</v-flex
        >
      </v-layout>
      <v-layout align-start class="pr-4" v-else>
        <div v-if="question.question_type === 'upload' && allowFileSelection">
          <v-combobox
            :items="selectableDocuments"
            v-model="question.uploaded_documents"
            item-value="source"
            :label="$t('documents.selectFiles')"
            multiple
            chips
            @change="onSelectFiles($event, question)"
          >
            <template slot="selection" slot-scope="data">
              <v-chip>
                {{ getDocumentName(data.item.source) }}
              </v-chip>
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title style="height: auto">
                  <span class="text-xs-left">{{
                    getDocumentName(data.item.source)
                  }}</span>
                  <v-chip
                    v-if="
                      data.item.form_name_verified === true &&
                        !isEmpty(data.item.detailed_name)
                    "
                    >{{ data.item.detailed_name }}</v-chip
                  >
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-combobox>
        </div>
        <div v-else-if="question.question_type === 'upload'">
          Uploaded:
          <v-tooltip
            bottom
            :key="i"
            v-for="(document, i) in listDocuments(question.answer)"
          >
            <v-chip
              slot="activator"
              small
              @click="
                $emit('preview-document', findExtractedDocument(document))
              "
            >
              {{ getDocumentName(document) }}
            </v-chip>
            <span v-if="endsWithAny(supportedExtensionsForPreview, document)"
              >Click to preview</span
            >
            <span v-else>Click to download</span>
          </v-tooltip>
        </div>
        <sx-html
          v-else
          :text="question.formatted_answer"
          class="font-weight-bold"
        />
        <v-icon
          class="mx-2 questionnaire-arrow"
          v-if="!isEmpty(getFollowUpQuestions(question))"
          >arrow_right_alt</v-icon
        >
        <v-layout column>
          <v-layout
            column
            align-start
            :key="i"
            v-for="(followUpQuestion, i) in getFollowUpQuestions(question)"
          >
            <v-layout align-center class="grey--text text--darken-2">
              <div class="mr-1">
                <sx-html :text="followUpQuestion.text" />{{
                  followUpQuestion.optional ? ' (optional)' : ''
                }}
              </div>

              <v-tooltip bottom class="mx-1">
                <i
                  class="primary--text"
                  :class="
                    filteredComments(followUpQuestion).length > 0
                      ? 'material-icons'
                      : 'material-icons-outlined'
                  "
                  style="cursor: pointer;font-size: 18px"
                  slot="activator"
                  @click="$emit('open-comment-dialog', followUpQuestion)"
                >
                  chat
                </i>
                <span
                  >View Notes ({{
                    filteredComments(followUpQuestion).length
                  }})</span
                >
              </v-tooltip>
              <v-chip
                small
                class="my-0"
                v-if="followUpQuestion.answer_by && !followUpQuestion.answer"
                >Marked to be
                {{
                  followUpQuestion.question_type === 'upload'
                    ? 'uploaded'
                    : 'answered'
                }}
                by {{ moment(followUpQuestion.answer_by).format('ll') }}</v-chip
              >
              <v-tooltip bottom class="mx-1">
                <v-icon
                  slot="activator"
                  v-if="showQuestionActions && isEmpty(followUpQuestion.answer)"
                  class="success--text"
                  size="20"
                  @click="$emit('toggle-completed', followUpQuestion)"
                >
                  check
                </v-icon>
                <span>Mark Completed</span>
              </v-tooltip>
              <v-tooltip bottom class="mx-1" v-if="showQuestionActions">
                <v-icon
                  slot="activator"
                  class="error--text"
                  size="18"
                  @click="$emit('delete-question', followUpQuestion)"
                >
                  delete_outline
                </v-icon>
                <span>Remove</span>
              </v-tooltip>
            </v-layout>
            <v-layout
              align-start
              column
              v-if="
                followUpQuestion.question_type === 'entries' &&
                  !predefinedQuestionAnswers.includes(followUpQuestion.answer)
              "
              class="mt-2 mr-4"
            >
              <v-layout
                align-center
                wrap
                class="outlined py-2 mb-2"
                :key="entryNumber2"
                v-for="(entryNumber2, i) in getTriggers(followUpQuestion)"
              >
                <v-avatar class="my-1 ml-2 primary white--text" size="20">{{
                  i + 1
                }}</v-avatar>
                <v-layout
                  align-start
                  :key="i"
                  v-for="(secondFollowUpQuestion,
                  i) in getFollowUpQuestionsWithTrigger(
                    followUpQuestion,
                    entryNumber2,
                  )"
                >
                  <v-layout align-center class="grey--text text--darken-2 px-3">
                    <div class="mr-2">
                      <span v-html="secondFollowUpQuestion.text" />:
                    </div>
                    <template v-if="secondFollowUpQuestion.answer">
                      <template
                        v-if="secondFollowUpQuestion.question_type === 'upload'"
                      >
                        <v-tooltip
                          bottom
                          :key="i"
                          v-for="(document, i) in listDocuments(
                            secondFollowUpQuestion.answer,
                          )"
                        >
                          <v-chip
                            slot="activator"
                            small
                            @click="
                              $emit(
                                'preview-document',
                                findExtractedDocument(document),
                              )
                            "
                          >
                            {{ getDocumentName(document) }}
                          </v-chip>
                          <span
                            v-if="
                              endsWithAny(
                                supportedExtensionsForPreview,
                                document,
                              )
                            "
                            >Click to preview</span
                          >
                          <span v-else>Click to download</span>
                        </v-tooltip>
                      </template>
                      <div v-else class="font-weight-bold">
                        {{ secondFollowUpQuestion.formatted_answer }}
                      </div>
                    </template>
                    <div v-else class="grey--text">Blank</div>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-flex
                class="mb-2 font-weight-bold"
                v-if="isEmpty(getTriggers(followUpQuestion))"
                >None</v-flex
              >
            </v-layout>
            <v-layout
              align-start
              v-else-if="
                followUpQuestion.answer ||
                  (followUpQuestion.question_type === 'upload' &&
                    allowFileSelection)
              "
            >
              <v-icon class="mr-2 questionnaire-arrow"
                >subdirectory_arrow_right</v-icon
              >
              <span
                class="my-1 darkgrey--text"
                v-if="
                  predefinedQuestionAnswers.includes(followUpQuestion.answer)
                "
              >
                {{ followUpQuestion.answer
                }}{{ uploadLaterDate(followUpQuestion) }}
                <v-icon
                  slot="activator"
                  v-if="
                    showQuestionActions &&
                      followUpQuestion.answer === 'Marked Completed'
                  "
                  class="error--text"
                  size="18"
                  @click="$emit('toggle-completed', followUpQuestion)"
                >
                  cancel
                </v-icon>
              </span>
              <v-layout align-center v-else>
                <div
                  class="mt-1"
                  v-if="
                    followUpQuestion.question_type === 'upload' &&
                      allowFileSelection
                  "
                >
                  <v-combobox
                    :items="selectableDocuments"
                    v-model="followUpQuestion.uploaded_documents"
                    item-value="source"
                    :label="$t('documents.selectFiles')"
                    multiple
                    chips
                    @change="onSelectFiles($event, followUpQuestion)"
                  >
                    <template slot="selection" slot-scope="data">
                      <v-chip>
                        {{ getDocumentName(data.item.source) }}
                      </v-chip>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-list-tile-content>
                        <v-list-tile-title style="height: auto">
                          <span class="text-xs-left">{{
                            getDocumentName(data.item.source)
                          }}</span>
                          <v-chip
                            v-if="
                              data.item.form_name_verified === true &&
                                !isEmpty(data.item.detailed_name)
                            "
                            >{{ data.item.detailed_name }}</v-chip
                          >
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </v-combobox>
                </div>

                <div
                  class="mt-1"
                  v-else-if="followUpQuestion.question_type === 'upload'"
                >
                  Uploaded:
                  <v-tooltip
                    bottom
                    :key="i"
                    v-for="(document, i) in listDocuments(
                      followUpQuestion.answer,
                    )"
                  >
                    <v-chip
                      slot="activator"
                      small
                      @click="
                        $emit(
                          'preview-document',
                          findExtractedDocument(document),
                        )
                      "
                    >
                      {{ getDocumentName(document) }}
                    </v-chip>
                    <span
                      v-if="
                        endsWithAny(supportedExtensionsForPreview, document)
                      "
                      >Click to preview</span
                    >
                    <span v-else>Click to download</span>
                  </v-tooltip>
                </div>
                <div v-else class="font-weight-bold mt-1">
                  {{ followUpQuestion.formatted_answer }}
                </div>
              </v-layout>
              <v-icon
                class="mx-2 mt-1 questionnaire-arrow"
                v-if="!isEmpty(getFollowUpQuestions(followUpQuestion))"
                >arrow_right_alt</v-icon
              >
              <v-layout column>
                <v-layout
                  class="my-1"
                  :key="i"
                  v-for="(secondFollowUpQuestion, i) in getFollowUpQuestions(
                    followUpQuestion,
                  )"
                  align-center
                >
                  <div class="mr-1">
                    <sx-html :text="secondFollowUpQuestion.text" />{{
                      secondFollowUpQuestion.optional ? ' (optional)' : ''
                    }}
                  </div>
                  <v-chip
                    small
                    class="my-0"
                    v-if="
                      secondFollowUpQuestion.answer_by &&
                        !secondFollowUpQuestion.answer
                    "
                    >Marked to be
                    {{
                      secondFollowUpQuestion.question_type === 'upload'
                        ? 'uploaded'
                        : 'answered'
                    }}
                    by
                    {{
                      moment(secondFollowUpQuestion.answer_by).format('ll')
                    }}</v-chip
                  >
                  <v-tooltip bottom class="mx-1">
                    <i
                      class="primary--text"
                      :class="
                        filteredComments(secondFollowUpQuestion).length > 0
                          ? 'material-icons'
                          : 'material-icons-outlined'
                      "
                      style="cursor: pointer;font-size: 18px"
                      slot="activator"
                      @click="
                        $emit('open-comment-dialog', secondFollowUpQuestion)
                      "
                    >
                      chat
                    </i>
                    <sc-icon name="chat"></sc-icon>

                    <span
                      >View Notes ({{
                        filteredComments(secondFollowUpQuestion).length
                      }})</span
                    >
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    class="mx-2"
                    v-if="
                      showQuestionActions &&
                        (isEmpty(secondFollowUpQuestion.answer) ||
                          isSorabanAdmin)
                    "
                  >
                    <v-icon
                      slot="activator"
                      class="success--text"
                      size="20"
                      @click="$emit('toggle-completed', secondFollowUpQuestion)"
                    >
                      check
                    </v-icon>
                    <span>Mark Completed</span>
                  </v-tooltip>
                  <v-tooltip bottom class="mx-1" v-if="showQuestionActions">
                    <v-icon
                      slot="activator"
                      class="error--text"
                      size="18"
                      @click="$emit('delete-question', secondFollowUpQuestion)"
                    >
                      delete_outline
                    </v-icon>
                    <span>Remove</span>
                  </v-tooltip>
                  <v-icon
                    v-if="secondFollowUpQuestion.answer"
                    class="mr-2 questionnaire-arrow"
                    >arrow_right_alt</v-icon
                  >
                  <span
                    class="my-1 darkgrey--text"
                    v-if="
                      predefinedQuestionAnswers.includes(
                        secondFollowUpQuestion.answer,
                      )
                    "
                  >
                    {{ secondFollowUpQuestion.answer
                    }}{{ uploadLaterDate(secondFollowUpQuestion) }}
                    <v-icon
                      slot="activator"
                      v-if="
                        showQuestionActions &&
                          secondFollowUpQuestion.answer === 'Marked Completed'
                      "
                      class="error--text"
                      size="18"
                      @click="$emit('toggle-completed', secondFollowUpQuestion)"
                    >
                      cancel
                    </v-icon>
                  </span>
                  <v-layout
                    v-else-if="
                      secondFollowUpQuestion.answer ||
                        (secondFollowUpQuestion.question_type === 'upload' &&
                          allowFileSelection)
                    "
                    bottom
                  >
                    <div
                      v-if="
                        secondFollowUpQuestion.question_type === 'upload' &&
                          allowFileSelection
                      "
                    >
                      <v-combobox
                        :items="selectableDocuments"
                        v-model="secondFollowUpQuestion.uploaded_documents"
                        item-value="source"
                        :label="$t('documents.selectFiles')"
                        multiple
                        chips
                        @change="onSelectFiles($event, secondFollowUpQuestion)"
                      >
                        <template slot="selection" slot-scope="data">
                          <v-chip>
                            {{ getDocumentName(data.item.source) }}
                          </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title style="height: auto">
                              <span class="text-xs-left">{{
                                getDocumentName(data.item.source)
                              }}</span>
                              <v-chip
                                v-if="
                                  data.item.form_name_verified === true &&
                                    !isEmpty(data.item.detailed_name)
                                "
                                >{{ data.item.detailed_name }}</v-chip
                              >
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-combobox>
                    </div>
                    <div
                      v-else-if="
                        secondFollowUpQuestion.question_type === 'upload'
                      "
                    >
                      Uploaded:
                      <v-tooltip
                        bottom
                        :key="i"
                        v-for="(document, i) in listDocuments(
                          secondFollowUpQuestion.answer,
                        )"
                      >
                        <v-chip
                          slot="activator"
                          small
                          @click="
                            $emit(
                              'preview-document',
                              findExtractedDocument(document),
                            )
                          "
                        >
                          {{ getDocumentName(document) }}
                        </v-chip>
                        <span
                          v-if="
                            endsWithAny(supportedExtensionsForPreview, document)
                          "
                          >Click to preview</span
                        >
                        <span v-else>Click to download</span>
                      </v-tooltip>
                    </div>
                    <div
                      v-else-if="
                        secondFollowUpQuestion.question_type === 'multiple'
                      "
                    >
                      Selected
                      <span class="font-weight-bold">{{
                        secondFollowUpQuestion.answer
                      }}</span>
                    </div>
                    <div v-else class="font-weight-bold">
                      {{ secondFollowUpQuestion.answer }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-layout>
</template>
<script>
import QuestionnaireMixin from '@/mixins/QuestionnaireMixin';
import DocumentMixin from '@/mixins/DocumentMixin';
import AdminFunctionsMixin from '@/mixins/AdminFunctionsMixin';
import UtilsMixins from '@/mixins/UtilsMixins';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import PreviewDocument from '@/components/PreviewDocument';
import {
  supportedExtensionsForPreview,
  customSections,
  predefinedQuestionAnswers,
} from '@/constants/variables';
import { mapGetters } from 'vuex';
import SxHtml from '@/components/sx/SxHtml';

export default {
  name: 'QuestionnaireQuestionView',
  mixins: [QuestionnaireMixin, DocumentMixin, AdminFunctionsMixin, UtilsMixins],
  components: {
    PreviewDocument,
    SxHtml,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    currentQuestionnaire: {
      required: true,
      type: Object,
    },
    showQuestionActions: {
      type: Boolean,
    },
    allowFileSelection: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      predefinedQuestionAnswers,
      customSections,
      supportedExtensionsForPreview,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },
  methods: {
    isEmpty,
    moment,
    uploadLaterDate(question) {
      if (
        question.answer === 'Upload Later' ||
        question.answer === 'Answer Later'
      ) {
        if (question.answer_by) {
          return ` (${question.answer_by})`;
        } else {
          return ` (Not specified when)`;
        }
      } else {
        return '';
      }
    },
    questionAnswered(question) {
      return !isEmpty(question.answer) && !question.optional;
    },
    getFollowUpQuestions(question) {
      if (question.question_type === 'multiple') {
        return this.currentQuestionnaire.questionnaire_questions.filter(
          q =>
            q.follow_up_question_id === question.id &&
            question.answer.includes(q.trigger_for_follow_up_question),
        );
      } else {
        return this.currentQuestionnaire.questionnaire_questions.filter(
          q =>
            q.follow_up_question_id === question.id &&
            q.trigger_for_follow_up_question === question.answer,
        );
      }
    },
    getFollowUpQuestionsWithTrigger(question, trigger) {
      if (this.isSpecialSection(question.section)) {
        return this.currentQuestionnaire.questionnaire_questions
          .filter(
            q =>
              q.follow_up_question_id === question.id &&
              q.trigger_for_follow_up_question === trigger &&
              !isEmpty(q.answer),
          )
          .sort((a, b) => a.id - b.id);
      } else {
        return this.currentQuestionnaire.questionnaire_questions
          .filter(
            q =>
              q.follow_up_question_id === question.id &&
              q.trigger_for_follow_up_question === trigger,
          )
          .sort((a, b) => a.id - b.id);
      }
    },
    isSpecialSection(section) {
      return (
        this.customSections.map(s => s.name) +
        this.customSections.map(s => s.otherNames).flat()
      ).includes(section);
    },
    getTriggers(question) {
      return this.currentQuestionnaire.questionnaire_questions
        .filter(
          q =>
            q.follow_up_question_id === question.id &&
            q.trigger_for_follow_up_question !== 'Template',
        )
        .map(q => q.trigger_for_follow_up_question)
        .filter(this.onlyUnique);
    },
    listDocuments(answer) {
      return answer
        .split('&!&')
        .filter((item, index) => !(index === 0 && item === ''));
    },
  },
  async mounted() {
    if (this.question.question_type === 'multiple' && this.question.answer) {
      this.multipleSelectValues = this.question.answer.split('&!&');
    }
  },
};
</script>
<style lang="postcss" scoped>
.bordered {
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #d3d3d3;
}
.questionnaire-arrow {
  color: #abb3c0 !important;
}
.outlined {
  border: solid 0.2px rgba(9, 30, 66, 0.06) !important;
}
.light-background {
  background-color: #f5f8ff;
  overflow: hidden;
}
</style>
